import script from "./Reward.vue?vue&type=script&setup=true&lang=ts"
export * from "./Reward.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__